import axios from 'axios';

const BASEURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// In order-controller.js
// In order-controller.js
export const fetchOrders = async (page, limit, status, search, startDate, endDate, syncroFilter, platformFilter) => {
    try {
        // Convert parameters to proper format if needed
        page = parseInt(page) || 1;
        limit = parseInt(limit) || 10;
        
        // Make sure parameters are treated as strings for proper checking
        status = String(status || '');
        search = String(search || '');
        startDate = String(startDate || '');
        endDate = String(endDate || '');
        
        // If endDate is 'true', it means the parameters got mixed up - this is a crucial check!
        if (endDate === 'true' || endDate === 'false' || endDate === 'null') {
            syncroFilter = endDate;
            endDate = '';
        }

        if(status == "all"){
          status = null;
        }
        
        // Build URL with all parameters including platform
        let url = `${BASEURL}/BonCommande/Pagination?PageNumber=${page}&Size=${limit}`;
        
        if (status && status !== 'all') url += `&etat=${encodeURIComponent(status)}`;
        if (search) url += `&searchTerms=${encodeURIComponent(search)}`;
        if (startDate) url += `&dateDebut=${encodeURIComponent(startDate)}`;
        if (endDate) url += `&dateFin=${encodeURIComponent(endDate)}`;
        
        // Only add syncro filter if it's a valid value
        if (syncroFilter === 'true' || syncroFilter === 'false') {
            url += `&syncro=${syncroFilter}`;
        }
        
        // Add platform filter if provided and not 'all'
        if (platformFilter && platformFilter !== '' && platformFilter !== 'all') {
            url += `&platformId=${encodeURIComponent(platformFilter)}`;
        }
        
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

export const fetchPhoneOrderWarnings = async (phone) => {
  try {
    const url = `${BASEURL}/BonCommande/WarnningNumberTel?Tel=${encodeURIComponent(phone)}`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching phone order warnings:', error);
    throw error;
  }
};

export const createOrder = async (orderData) => {
  try {
      
      const response = await axios.post(`${BASEURL}/BonCommande/save`, orderData, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
      });
      
      return response.data;
  } catch (error) {
      console.error('Error in createOrder API call:', error);
      
      if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error('Response data:', error.response.data);
          console.error('Response status:', error.response.status);
          console.error('Response headers:', error.response.headers);
      } else if (error.request) {
          // The request was made but no response was received
          console.error('No response received:', error.request);
      } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error message:', error.message);
      }
      
      throw error;
  }
};

export const updateOrder = async (orderId, orderData) => {
  try {
      
      const response = await axios.put(`${BASEURL}/BonCommande/update/${orderId}`, orderData, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
      });
      
      return response.data;
  } catch (error) {
      console.error('Error in updateOrder API call:', error);
      
      if (error.response) {
          console.error('Response data:', error.response.data);
          console.error('Response status:', error.response.status);
          console.error('Response headers:', error.response.headers);
      } else if (error.request) {
          console.error('No response received:', error.request);
      } else {
          console.error('Error message:', error.message);
      }
      
      throw error;
  }
};

export const fetchOrderById = async (orderId) => {
  try {
    const response = await fetch(`${BASEURL}/BonCommande/ById/${orderId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch order with ID ${orderId}:`, error);
    throw error;
  }
};

export const updateOrderStatus = async (orderId, status, orderIds = []) => {
  try {
    // Determine which data to send based on parameters
    let requestData;
    
    if (orderId) {
      // If orderId is provided, use single order update
      requestData = { id: [orderId], etat: status };
    } else if (orderIds && orderIds.length > 0) {
      // If orderIds array is provided and not empty, use batch update
      requestData = { 
        id: orderIds,
        etat: status 
      };
    } else {
      // If neither is provided, throw an error
      throw new Error('Either orderId or orderIds must be provided');
    }
    
    const response = await axios.patch(`${BASEURL}/BonCommande/updatestatus`, requestData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    return response.data;
  } catch (error) {
    // Enhanced error logging
    if (orderId) {
      console.error(`Error in updateOrderStatus API call for order ${orderId} and status ${status}:`, error);
    } else {
      console.error(`Error in updateOrderStatus API call for ${orderIds?.length || 0} orders and status ${status}:`, error);
    }
    
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    
    throw error;
  }
};
export const fetchOrdersHeader = async () => {
  try {
    let url = `${BASEURL}/boncommande/getheader`;
        
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch Orders:', error);
    throw error;
  }
};

export const fetchOrderNewReference = async () =>{
  try {
    let url = `${BASEURL}/numerodocument/boncommande`;
        
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch Orders:', error);
    throw error;
  }
}

export const syncronizeOrders = async (orders) => {
  try {
    let url = `${BASEURL}/boncommande`;
    console.log('those are the orders to sync', orders);
    const response = await axios.patch(url, orders, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to synchronize orders:', error);
    throw error;
  }
}

export const deleteOrder = async (orderId) => {
  try {
    const response = await axios.delete(`${BASEURL}/BonCommande/${orderId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    // No need to check response.ok with axios!
    return response.data;
  } catch (error) {
    console.error(`Failed to delete order with ID ${orderId}:`, error);
    throw error;
  }
};

export const updateOrderProduct = async (orderData) => {
  try {
    // Replace with your actual API endpoint for updating orders
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/BonCommande/PatchAbondonnedBonCommande`, orderData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update order:', error);
    throw error;
  }
};

// Add this new function to the end of the file
export const trackOrders = async (orderIds) => {
  try {
    console.log('Orders to track:', orderIds);
    
    const response = await axios.patch(`${BASEURL}/BonCommande/Tracking`, orderIds, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to track orders:', error);
    
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    
    throw error;
  }
};

export const fetchOrdersWithFilters = async (page = 1, limit = 10, status = '', search = '', startDate = '', endDate = '', syncroFilter = '', platformFilter = '') => {
    try {
        console.log("Fetching orders with filters:", {
            page, limit, status, search, startDate, endDate, syncroFilter, platformFilter
        });

        // Validate parameters and handle edge cases
        if (typeof endDate === 'boolean' || (endDate && endDate.length < 5)) {
            console.warn("Parameter mixup detected! endDate contains syncro value:", endDate);
            // Move the syncro value to syncroFilter and clear endDate
            syncroFilter = endDate;
            endDate = '';
        }

        if(status == "all"){
          status = null;
        }
        
        
        // Build URL with validated parameters
        let url = `${BASEURL}/BonCommande/Pagination?PageNumber=${page}&Size=${limit}`;
        
        if (status) url += `&etat=${encodeURIComponent(status)}`;
        if (search) url += `&searchTerms=${encodeURIComponent(search)}`;
        if (startDate) url += `&dateDebut=${encodeURIComponent(startDate)}`;
        if (endDate) url += `&dateFin=${encodeURIComponent(endDate)}`;
        
        // Only add syncro filter if it's a valid value
        if (syncroFilter === 'true' || syncroFilter === 'false') {
            url += `&syncro=${syncroFilter}`;
        }
        
        // Add platform filter if provided
        if (platformFilter && platformFilter !== '' && platformFilter !== 'all') {
            url += `&platformId=${encodeURIComponent(platformFilter)}`;
        }
        
        // Log the final URL for debugging
        console.log("Final API URL:", url);
        
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("API Response:", data);
        return data;
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

// Add this new function to the existing order-controller.js file

export const importOrders = async (barcodes) => {
    try {
        console.log('Importing orders with barcodes:', barcodes);

        const response = await fetch(`${BASEURL}/boncommande/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(barcodes)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Import successful:', result);
        return result;
    } catch (error) {
        console.error('Error importing orders:', error);
        throw error;
    }
};

// Add function to update call status
export const updateOrderCallStatus = async (orderId, callType) => {
    try {
        const response = await fetch(`${BASEURL}/BonCommande/Call/${orderId}/${callType}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return { success: true, status: response.status };
    } catch (error) {
        console.error('Error updating call status:', error);
        throw error;
    }
};

// Update AvisClient and Commentaire for an order
export const updateOrderAvisCommentaire = async (orderId, avisClient, commentaire) => {
    try {
        const response = await fetch(`${BASEURL}/BonCommande/UpdateAvisCommentaire/${orderId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ avisClient, commentaire })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return { success: true };
    } catch (error) {
        console.error('Error updating avis/commentaire:', error);
        throw error;
    }
};

export const generateTickets = async (orderIds) => {
    try {
    const ids = Array.isArray(orderIds) ? orderIds : [orderIds];
    if (ids.length === 0) {
      return;
    }

    const authToken = localStorage.getItem('authToken');
    const printWindow = window.open('', '_blank');

    if (printWindow) {
      printWindow.document.write('<html><head><title>Tickets</title></head><body style="font-family: Arial, sans-serif; padding: 16px;">Preparation des tickets...</body></html>');
      printWindow.document.close();
    }

    // Collect all ticket pages as images (one image per label page)
    const allPages = [];

    for (const id of ids) {
      const response = await fetch(`${BASEURL}/Ticket/image/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const base64Images = await response.json();
      for (const b64 of base64Images) {
        allPages.push({ id, src: 'data:image/png;base64,' + b64 });
      }
    }

    if (!printWindow) {
      const w = window.open('');
      w.document.write('<img src="' + allPages[0].src + '" style="width:100mm"/>');
      return;
    }

    // Build HTML pages - each image is one print page
    const pagesHtml = allPages.map((p) =>
      '<div class="ticket-page"><img src="' + p.src + '" /></div>'
    ).join('');

    printWindow.document.open();
    printWindow.document.write(`
      <html>
      <head>
        <title>Tickets</title>
        <style>
          @page {
            size: 100mm 150mm;
            margin: 0mm !important;
          }
          * { margin: 0; padding: 0; box-sizing: border-box; }
          html, body { margin: 0 !important; padding: 0 !important; }

          @media print {
            .toolbar { display: none !important; }
            .preview { padding: 0 !important; background: white !important; margin: 0 !important; }
            .ticket-page {
              width: 100mm;
              height: 150mm;
              page-break-after: always;
              overflow: visible;
              margin-top: -30mm;
            }
            .ticket-page:last-child {
              page-break-after: avoid;
            }
            .ticket-page img {
              width: 100mm;
              height: 150mm;
              display: block;
            }
          }

          @media screen {
            body { background: #e0e0e0; font-family: Arial, sans-serif; }
            .toolbar {
              position: sticky; top: 0; z-index: 10;
              display: flex; align-items: center; gap: 8px;
              padding: 10px 16px; background: #111; color: #fff;
            }
            .toolbar button {
              border: 0; background: #fff; color: #111;
              padding: 8px 16px; cursor: pointer; font-weight: 600; font-size: 14px;
            }
            .toolbar .count { margin-left: auto; font-size: 13px; }
            .preview {
              display: flex; flex-direction: column; align-items: center;
              gap: 20px; padding: 20px;
            }
            .ticket-page {
              width: 100mm; height: 150mm;
              background: white; box-shadow: 0 2px 8px rgba(0,0,0,.15);
            }
            .ticket-page img {
              width: 100mm; height: 150mm; display: block;
            }
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <button id="printAll">Imprimer tout</button>
          <span class="count">${allPages.length} page(s)</span>
        </div>
        <div class="preview">
          ${pagesHtml}
        </div>
        <script>
          document.getElementById('printAll').addEventListener('click', function() { window.print(); });
          setTimeout(function() { window.print(); }, 800);
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
    } catch (error) {
        console.error('Error generating tickets:', error);
        throw error;
    }
};